
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/react-circular-progress",
      function () {
        return require("private-next-pages/joy-ui/react-circular-progress.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/react-circular-progress"])
      });
    }
  